import React, { useEffect, useState } from "react";
import { groupByKey } from "../../../../commonFunctions/arrayFunc";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import Button from "../../../../components/FormComponents/Button";
import ChipsInput from "../../../../components/FormComponents/ChipsInput";
import Input from "../../../../components/FormComponents/Input";
import MultiSelectBox from "../../../../components/FormComponents/MultiSelectBox";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import { MasterDataSelections } from "../EditFieldMasterData";
import Label from "../../../../components/FormComponents/Label";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const OnChangeAction = ({ editFieldData, setEditFieldData, allKeysOfFields }) => {
  const [isAddCondition, setIsAddCondition] = useState(false);
  const handleCondition = (index, type, data) => {
    const copyOfEditFieldData = { ...editFieldData };
    if (type === "edit") {
      copyOfEditFieldData.on_change[index] = data;
    }
    if (type === "add") {
      copyOfEditFieldData.on_change.push(data);
    }
    if (type === "delete") {
      copyOfEditFieldData.on_change.splice(index, 1);
    }
    setEditFieldData(copyOfEditFieldData);
  };
  const handleAddCondition = () => {
    setIsAddCondition(true);
  };
  return (
    <div className="flex_column gap_2">
      <div className="flex_column gap_4">
        {editFieldData.on_change.map((condition, index) => (
          <SingleOnChangeCondition
            key={"onChange" + index}
            condition={condition}
            handleCondition={(type, data) => handleCondition(index, type, data)}
            allKeysOfFields={allKeysOfFields}
          />
        ))}
      </div>

      {!isAddCondition ? (
        <div className="d_flex justify_end">
          <Button variant="secondary" onClick={handleAddCondition}>
            + Condition
          </Button>
        </div>
      ) : (
        <SingleOnChangeAction
          value={{
            eq: "",
            neq: "",
            gt: "",
            lt: "",
            has: [],
            action: []
          }}
          handleAction={(data) => {
            setIsAddCondition(false);
            handleCondition(null, "add", data);
          }}
          allKeysOfFields={allKeysOfFields}
        />
      )}
    </div>
  );
};

const SingleOnChangeCondition = ({ condition, handleCondition, allKeysOfFields }) => {
  const [isEditModeOpen, setIsEditModeOpen] = useState(false);

  const handleOnChangeAction = (newCondition) => {
    setIsEditModeOpen(false);
    handleCondition("edit", newCondition);
  };

  return (
    <>
      {isEditModeOpen ? (
        <SingleOnChangeAction value={condition} handleAction={handleOnChangeAction} allKeysOfFields={allKeysOfFields} />
      ) : (
        <div className="on_change_action_preview position_relative p_3" style={{ background: "var(--builder-plain)" }}>
          <div
            className="overlay_cover d_flex gap_1 justify_center align_center"
            style={{ backgroundColor: "rgb(139 139 139 / 10%", opacity: "1" }}
          >
            <ButtonActionIcon type="edit" onClick={() => setIsEditModeOpen(true)} />
            <ButtonActionIcon type="delete" onClick={() => handleCondition("delete")} />
          </div>
          <FieldOnChangeConditionSummary condition={condition} allKeysOfFields={allKeysOfFields} />
        </div>
      )}
    </>
  );
};

const FieldOnChangeConditionSummary = ({ condition }) => {
  return (
    <div>
      <div>
        Equal to <strong>{condition.eq || "NONE"}</strong>, Not Equal to <strong>{condition.neq || "NONE"}</strong>,
        Less than <strong>{condition.gt || "NONE"}</strong>, Greater than <strong>{condition.lt || "NONE"}</strong>,
      </div>
      <div>
        Has <strong>{condition.has.join(", ")}</strong>
      </div>
      <div>
        Actions <strong>{condition.action.map((item) => item.type).join(",")}</strong>
      </div>
    </div>
  );
};

const isActionsHasData = (data) => {
  switch (data.type) {
    case "show":
    case "hide":
    case "copy_value":
      // For 'show', 'hide', and 'copy_value', check if 'child_id' exists and has a valid length
      if (Array.isArray(data.child_id) && data.child_id.length > 0) {
        return true;
      }
      break;
    case "set_options":
    case "set_value":
      // For 'set_options' and 'set_value', check if 'data_key' exists
      if (data.data_key) {
        return true;
      }
      break;
    case "disable":
    case "enable":
    case "reset":
      if (Array.isArray(data.child_id) && data.child_id.length > 0) {
        return true;
      }
      break;
    default:
      return false;
  }
  return false;
};

const SingleOnChangeAction = ({ value, handleAction, allKeysOfFields }) => {
  const [singleOnChangeCondition, setSingleOnChangeCondition] = useState(value);

  const handleActionChange = (data) => {
    const newActions = [];
    Object.keys(data).forEach((key) => {
      const actionsArray = data[key];
      actionsArray.forEach((singleAcrion) => {
        const isValid = isActionsHasData(singleAcrion);
        if (isValid) {
          newActions.push(singleAcrion);
        }
      });
    });
    updateLocalAndParentState("action", newActions);
  };

  const updateLocalAndParentState = (name, value) => {
    const newCondition = { ...singleOnChangeCondition, [name]: value };
    setSingleOnChangeCondition(newCondition);
  };

  const handleAddOrEditCondition = () => {
    handleAction(singleOnChangeCondition);
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    updateLocalAndParentState(name, value);
  };

  return (
    <div className="builder_form form_data_action_wrapper">
      <Label className="form_appuser_filter_tag">Actions</Label>
      <div className="field_horizontal_container">
        <Input
          label="Greater than"
          type="number"
          name="gt"
          value={singleOnChangeCondition.gt}
          onChange={handleChangeInput}
        />
        <Input
          label="Less than"
          type="number"
          name="lt"
          value={singleOnChangeCondition.lt}
          onChange={handleChangeInput}
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label="Equals to"
          name="eq"
          value={singleOnChangeCondition.eq}
          onChange={handleChangeInput}
          containerClassName="w_50"
        />
        <Input
          label="Not Equals to"
          name="neq"
          value={singleOnChangeCondition.neq || ""}
          onChange={handleChangeInput}
          containerClassName="w_50"
        />
      </div>
      <ChipsInput
        label="Has"
        inputArray={singleOnChangeCondition.has}
        onChange={(data) => {
          setSingleOnChangeCondition({ ...singleOnChangeCondition, has: data });
        }}
      />
      <ActionsForSingleOnChangeCondition
        actions={value.action}
        onChange={handleActionChange}
        allKeysOfFields={allKeysOfFields}
      />
      <div className="d_flex justify_end">
        <Button size="small" variant="secondary" onClick={handleAddOrEditCondition}>
          <MaterialIcon name="save" style={{ fontSize: "16px" }} />
        </Button>
      </div>
    </div>
  );
};

const getConfigOfActionType = (type) => {
  switch (type) {
    case "show":
    case "hide":
    case "copy_value":
      return {
        child_id: [],
        type: type
      };
    case "set_options":
      return {
        child_id: "",
        data_key: "",
        label_from_col: "",
        method: "lookup",
        search_key_col: "",
        type: "set_options",
        value_from_col: ""
      };
    case "set_value":
      return {
        child_id: "",
        data_key: "",
        method: "lookup",
        search_key_col: "",
        type: "set_value",
        value_key_col: ""
      };
    case "disable":
    case "enable":
    case "reset":
      return {
        child_id: [],
        type: type
      };
    default:
      return null;
  }
};
const initialCheckboxValue = {
  show: false,
  hide: false,
  copy_value: false,
  set_options: false,
  set_value: false,
  disable: false,
  enable: false,
  reset: false
};
const ActionsForSingleOnChangeCondition = ({ actions, onChange, allKeysOfFields }) => {
  const [checkedValues, setCheckedValues] = useState(initialCheckboxValue);
  const [typeBasedActions, setTypeBasedActions] = useState(null);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const newCheckedValues = { ...checkedValues, [name]: checked };
    setCheckedValues(newCheckedValues);
  };

  const handleChangeAction = (value) => {
    const copyActions = { ...typeBasedActions };
    if (value.type === "set_options" || value.type === "set_value") {
      copyActions[value.type][value.payload.index] = value.payload.data;
    }
    if (value.type === "copy_value") {
      copyActions[value.type][value.payload.index].child_id = value.payload.data;
    }
    if (
      value.type === "show" ||
      value.type === "hide" ||
      value.type === "disable" ||
      value.type === "enable" ||
      value.type === "reset"
    ) {
      const newArray = value.payload.data || [];
      copyActions[value.type][value.payload.index].child_id = newArray.map((f) => f.id);
    }
    setTypeBasedActions(copyActions);
  };

  useEffect(() => {
    const { result, error } = groupByKey(actions, "type");
    if (error) {
      setTypeBasedActions(null);
    }
    let initialCheckboxValueAccordingData = initialCheckboxValue;
    Object.keys(result).forEach((key) => (initialCheckboxValueAccordingData[key] = true));

    setCheckedValues(initialCheckboxValueAccordingData);
    setTypeBasedActions({
      show: [getConfigOfActionType("show")],
      hide: [getConfigOfActionType("hide")],
      copy_value: [getConfigOfActionType("copy_value")],
      set_options: [getConfigOfActionType("set_options")],
      set_value: [getConfigOfActionType("set_value")],
      disable: [getConfigOfActionType("disable")],
      enable: [getConfigOfActionType("enable")],
      reset: [getConfigOfActionType("reset")],
      ...result
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeBasedActions) {
      onChange(typeBasedActions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeBasedActions]);

  if (!typeBasedActions) return null;
  return (
    <div className="flex_column gap_3">
      <Label className="font_weight_bold">Add actions</Label>
      <Input label="Show" type="checkbox" name="show" checked={checkedValues.show} onChange={handleCheckboxChange} />
      {checkedValues.show &&
        Array.isArray(typeBasedActions.show) &&
        typeBasedActions.show.map((showData, index) => {
          return (
            <MultiSelectBox
              key={"show" + index}
              options={Object.values(allKeysOfFields)}
              placeholder="Select a field"
              selectedData={showData.child_id}
              labelKey={["label"]}
              onChange={(data) =>
                handleChangeAction({
                  type: "show",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}

      <Input label="Hide" type="checkbox" name="hide" checked={checkedValues.hide} onChange={handleCheckboxChange} />
      {checkedValues.hide &&
        Array.isArray(typeBasedActions.hide) &&
        typeBasedActions.hide.map((hideData, index) => {
          return (
            <MultiSelectBox
              key={"hide" + index}
              options={Object.values(allKeysOfFields)}
              placeholder="Select a field"
              selectedData={hideData.child_id}
              labelKey={["label"]}
              onChange={(data) =>
                handleChangeAction({
                  type: "hide",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}

      <Input
        label="Disable"
        type="checkbox"
        name="disable"
        checked={checkedValues.disable}
        onChange={handleCheckboxChange}
      />
      {checkedValues.disable &&
        Array.isArray(typeBasedActions.disable) &&
        typeBasedActions.disable.map((disableData, index) => {
          return (
            <MultiSelectBox
              key={"disable" + index}
              options={Object.values(allKeysOfFields)}
              placeholder="Select fields to disable"
              selectedData={disableData.child_id}
              labelKey={["label"]}
              onChange={(data) =>
                handleChangeAction({
                  type: "disable",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}

      <Input
        label="Enable"
        type="checkbox"
        name="enable"
        checked={checkedValues.enable}
        onChange={handleCheckboxChange}
      />
      {checkedValues.enable &&
        Array.isArray(typeBasedActions.enable) &&
        typeBasedActions.enable.map((enableData, index) => {
          return (
            <MultiSelectBox
              key={"enable" + index}
              options={Object.values(allKeysOfFields)}
              placeholder="Select fields to enable"
              selectedData={enableData.child_id}
              labelKey={["label"]}
              onChange={(data) =>
                handleChangeAction({
                  type: "enable",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}

      <Input label="Reset" type="checkbox" name="reset" checked={checkedValues.reset} onChange={handleCheckboxChange} />
      {checkedValues.reset &&
        Array.isArray(typeBasedActions.reset) &&
        typeBasedActions.reset.map((enableData, index) => {
          return (
            <MultiSelectBox
              key={"reset" + index}
              options={Object.values(allKeysOfFields)}
              placeholder="Select fields to reset"
              selectedData={enableData.child_id}
              labelKey={["label"]}
              onChange={(data) =>
                handleChangeAction({
                  type: "reset",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}

      <Input
        label="Copy value"
        type="checkbox"
        name="copy_value"
        checked={checkedValues.copy_value}
        onChange={handleCheckboxChange}
      />
      {checkedValues.copy_value &&
        Array.isArray(typeBasedActions.copy_value) &&
        typeBasedActions.copy_value.map((copyValuedata, index) => {
          return (
            <SourceTargetKeyValue
              key={"copy_value" + index}
              selectedSourceTatget={copyValuedata.child_id}
              fields={Object.values(allKeysOfFields)}
              onChange={(data) =>
                handleChangeAction({
                  type: "copy_value",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}
      <Input
        label="Set options"
        type="checkbox"
        name="set_options"
        checked={checkedValues.set_options}
        onChange={handleCheckboxChange}
      />
      {checkedValues.set_options &&
        Array.isArray(typeBasedActions.set_options) &&
        typeBasedActions.set_options.map((setOptionData, index) => {
          return (
            <SetConditionActionOprionAndValue
              key={"set_options" + index}
              value={setOptionData}
              fields={Object.values(allKeysOfFields)}
              onChange={(data) =>
                handleChangeAction({
                  type: "set_options",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}
      <Input
        label="Set value"
        type="checkbox"
        name="set_value"
        checked={checkedValues.set_value}
        onChange={handleCheckboxChange}
      />
      {checkedValues.set_value &&
        Array.isArray(typeBasedActions.set_value) &&
        typeBasedActions.set_value.map((setValueData, index) => {
          return (
            <SetConditionActionOprionAndValue
              key={"set_value" + index}
              value={setValueData}
              fields={Object.values(allKeysOfFields)}
              onChange={(data) =>
                handleChangeAction({
                  type: "set_value",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
          );
        })}
    </div>
  );
};

const SourceTargetKeyValue = ({ selectedSourceTatget, fields, onChange }) => {
  const handleAdd = () => {
    onChange([...selectedSourceTatget, { source_key: "", target_key: "" }]);
  };

  const handleChange = (data) => {
    const copyArray = [...selectedSourceTatget];
    copyArray[data.payload.index][data.type] = data.payload.data.id;
    onChange(copyArray);
  };
  return (
    <div>
      <div className="builder_form">
        {selectedSourceTatget.map((value, index) => (
          <div className="d_flex gap_2 align_center" key={value.source_key}>
            <SingleSelectBox
              options={fields}
              placeholder="Select Source key"
              selectedData={value.source_key}
              labelKey={["label"]}
              onChange={(data) =>
                handleChange({
                  type: "source_key",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
            <SingleSelectBox
              options={fields}
              placeholder="Select Target key"
              selectedData={value.target_key}
              labelKey={["label"]}
              onChange={(data) =>
                handleChange({
                  type: "target_key",
                  payload: {
                    data: data,
                    index: index
                  }
                })
              }
            />
            <ButtonActionIcon type="delete" />
          </div>
        ))}
      </div>
      <div className="d_flex justify_end my_1">
        <Button variant="secondary" onClick={handleAdd}>
          +
        </Button>
      </div>
    </div>
  );
};

const SetConditionActionOprionAndValue = ({ value, onChange, fields }) => {
  const callOnChange = (name, newValue) => {
    onChange({ ...value, [name]: newValue });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    callOnChange(name, value);
  };
  const handleChangeMasterData = (id) => {
    callOnChange("data_key", id);
  };
  return (
    <div className="builder_form">
      <MasterDataSelections
        selectedMasterData={value.data_key}
        onChange={handleChangeMasterData}
        label="Select master data"
      />
      <Input label="Search key column" value={value.search_key_col} name="search_key_col" onChange={handleChange} />
      <SingleSelectBox
        selectedData={value.child_id}
        options={fields}
        onChange={(obj) => callOnChange("child_id", obj.id)}
        labelKey={["label"]}
        label="Select child ID"
        placeholder="Select child ID"
      />
      {value.type === "set_options" && (
        <>
          <Input label="Value from col" value={value.value_from_col} name="value_from_col" onChange={handleChange} />
          <Input label="Label from col" value={value.label_from_col} name="label_from_col" onChange={handleChange} />
        </>
      )}
      {value.type === "set_value" && (
        <Input label="Value key col" value={value.value_key_col} name="value_key_col" onChange={handleChange} />
      )}
    </div>
  );
};

export default OnChangeAction;
